import { useContext, useEffect } from "react";
import { Outlet } from "react-router-dom";
import { Container, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

import { BrandContext } from "../../App";
import LandingLayout from "../Layout/Layout";
import theme from "../../Theme";

import ScrollToTop from "../helpers/ScrollToTop";

import { useUI } from "../../contexts/UIContext";
import { useAuth } from "../../contexts/AuthContext";

export default function Dashboard() {
  const { brand, featureFlags } = useContext(BrandContext);

  const { showFooter, setSideMenuOpen, setLayoutMode } = useUI();
  const { loggedInUser } = useAuth();

  const navigate = useNavigate();

  useEffect(() => {
    setSideMenuOpen(false);
    return () => {
      setSideMenuOpen(true);
    };
  }, []);

  // Redirect on demand coach users if they land on dashboard
  useEffect(() => {
    if (
      loggedInUser.subscriptions?.on_demand_coaches?.length > 0 &&
      featureFlags?.on_demand_coach == true
    ) {
      setLayoutMode("minimal");
      navigate("/dashboard/on_demand_coach", { replace: true });
    }
  }, [loggedInUser, featureFlags]);

  return (
    <>
      <ScrollToTop />
      <LandingLayout>
        <div className="app-inner-container">
          <Outlet />
          {showFooter && (
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{
                mt: theme.containers.paddingDesktop,
                width: "100%",
                bottom: 5,
                textAlign: "center",
              }}
            >
              {"© "}
              {brand.name} {new Date().getFullYear()}
            </Typography>
          )}
        </div>
      </LandingLayout>
    </>
  );
}
